module.exports = __webpack_public_path__ + "static/media/brake-repair-red.f42fbc6a.svg";